export default __webpack_public_path__ + "static/media/01.3867ba28.png";